/**
 * @fileoverview Datas no idioma da tela (dd/mm/aaaa hh:mm em português), no
 * fuso do navegador. Extraído da tela de Equipe e permissões para os links
 * externos dos quadros do CRM usarem o mesmo formato.
 */

import { i18n } from "../translate/i18n";

const LOCALES = { pt: "pt-BR", en: "en-US", es: "es-ES" };

const format = (value, options) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const locale = LOCALES[String(i18n.language || "pt").slice(0, 2)] || LOCALES.pt;
  return date.toLocaleString(locale, options);
};

/** Data e hora no idioma da tela (dd/mm/aaaa hh:mm em português). */
export const formatDateTime = (value) =>
  format(value, { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

/** Só a data (dd/mm/aaaa em português). */
export const formatDate = (value) => format(value, { day: "2-digit", month: "2-digit", year: "numeric" });

/** A data no dia de São Paulo (os prazos das condições comerciais valem por ele), visto de qualquer fuso. */
export const formatSaoPauloDate = (value) => format(value, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "America/Sao_Paulo" });

/**
 * O dia como veio, sem o fuso: a Pagar.me manda o dia à 0h UTC (a próxima
 * cobrança "30/11" chega como 2026-11-30T00:00:00Z, que no fuso de São Paulo
 * ainda é 29/11).
 */
export const formatUtcDate = (value) => format(value, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });

/** Só a hora (hh:mm). */
export const formatTime = (value) => format(value, { hour: "2-digit", minute: "2-digit" });
